import styled from '@emotion/styled';
import { ViewType } from '../../../../types';
import { headerButtonView } from '../../../HeaderButtons/buttonsView';

import { Colors, helperButtonReset, helperTypographyText } from '@utex/ui-kit';

export function getButtonColor(view: ViewType) {
  switch (view) {
    case 'white':
      return headerButtonView['white-dim'];

    case 'black':
      return headerButtonView['black-dim'];

    default:
      return 'primary-dim';
  }
}

export const Container = styled('div')`
  position: relative;
  display: flex;
  align-items: center;
  margin-right: 2.4rem;
`;

interface BalanceButton {
  view: ViewType;
  isTooltipOpen: boolean;
}

export const BalanceButton = styled('button')<BalanceButton>`
  ${helperButtonReset};
  ${helperTypographyText({
    size: 'M',
    lh: 'M',
  })};
  z-index: 10;
  margin-right: 1rem;
  color: ${(props) =>
    props.view === 'white' && props.isTooltipOpen ? Colors.text.default : 'inherit'};
  transition: color 0.3s, opacity 0.3s;
  cursor: ${(props) => (props.isTooltipOpen ? 'default' : 'pointer')};

  &:hover {
    opacity: ${(props) => !props.isTooltipOpen && 0.5};
  }
`;
